import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const MediumRectangleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path d="M8.40002 3.6H15.6V20.4H8.40002V3.6Z" fill={color} />
    </BaseIcon>
  ),
);

MediumRectangleIcon.displayName = 'MediumRectangleIcon';
